module.exports = __webpack_public_path__ + "static/300x250.4621f68c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/multimedia/2019/300x250.jpg
// module id = 564
// module chunks = 116596815971312